export default "__VITE_ASSET__CoQ8Ho1y__"